// Components==============
import Consonants from 'components/UI/SoundTypes/Consonants';
import LongSounds from 'components/UI/SoundTypes/LongSounds';
import ShortSounds from 'components/UI/SoundTypes/ShortSounds';
import SpecialSounds from 'components/UI/SoundTypes/SpecialSounds';
import StupidSounds from 'components/UI/SoundTypes/StupidSound';
import TwoSymbolSounds from 'components/UI/SoundTypes/TwoSymbolSounds';
import { motion } from 'framer-motion';
import React, { useContext, useEffect } from 'react';
import { HomeContext } from 'screens/Home/Home';
import { initialPulse, pulse } from 'utilities/framerAnimations';
import { MenuContext } from '../../Menu';
import Popup from '../Popup/Popup';
import './City.module.scss';
// =========================

export default function City() {
    const { select, selected, setMenuPointer } = useContext(MenuContext);
    const {
        setWelcomeRight,
        welcomeSequence,
        setWelcomeX,
        setWelcomeY,
        setWelcomeLeft,
    } = useContext(HomeContext);

    useEffect(() => {
        if (
            welcomeSequence === 'klankenkaart' ||
            welcomeSequence === 'settings'
        ) {
            setWelcomeRight('0%');
            setWelcomeX('-100px');
            setWelcomeY('0');
            setWelcomeLeft('');
        }
    }, [welcomeSequence]);

    return (
        <div styleName="wrapper">
            <motion.button
                animate={
                    welcomeSequence === 'klankenkaart' ? pulse : initialPulse
                }
                initial={initialPulse}
                onClick={(e) => {
                    select('city');
                    setMenuPointer(e);
                }}
                type="button"
            >
                <img alt="city icon" src="/images/menu/icon-city.svg" />
            </motion.button>
            {selected === 'city' && (
                <Popup>
                    <div styleName="background">
                        <h3>Klankenkaart</h3>
                        <p>Korte klanken:</p>
                        <ShortSounds />
                        <p>Lange klanken:</p>
                        <LongSounds />
                        <p>Tweetekenklanken:</p>
                        <TwoSymbolSounds />
                        <p>Bijzondere klanken:</p>
                        <SpecialSounds />
                        <p>Medeklinkers:</p>
                        <Consonants />
                        <p>Stomme klank:</p>
                        <StupidSounds />
                    </div>
                </Popup>
            )}
        </div>
    );
}
